import heightMask from '@/utils/helpers/maskers/height';
import dateMask from '@/utils/helpers/maskers/date';
import timeMask from '@/utils/helpers/maskers/time/timeFormat';

const applyMask = (newValue, oldValue, metaType, suffix) => {
  switch (metaType) {
    case 'date':
      return dateMask(newValue);
    case 'time':
      return timeMask(newValue);
    case 'picker':
      return suffix === 'm'
        ? heightMask(newValue)
        : newValue;
  }
};

const setSelectedValueMask = (newValue, oldValue, metaType, suffix) => {
  if (newValue.length > oldValue.length) {
    return applyMask(newValue, oldValue, metaType, suffix);
  }

  return false;
};

export {
  setSelectedValueMask,
};
